import { ITheme, theme } from "../../utils/theme";

export const whiteBgWrapper = {
  background: (theme: ITheme) => theme.palette.common.white,
  borderRadius: '5px',
  p: 1,
}

export const inputStyle = (theme: ITheme) => ({
  m: 1,
  ' .MuiInputBase-root.MuiInput-root.MuiInput-underline.MuiInput-underline:hover:not(.Mui-disabled):not(.Mui-error)::before, .MuiInputBase-root.MuiInput-root.MuiInput-input.MuiInput-input:hover:not(.Mui-disabled):not(.Mui-error)::before': {
    display: 'none'
  },
  ' .MuiInputBase-root.MuiInput-root.MuiInput-underline.MuiInput-underline:hover:not(.Mui-disabled):not(.Mui-error)::after, .MuiInputBase-root.MuiInput-root.MuiInput-input.MuiInput-input:hover:not(.Mui-disabled):not(.Mui-error)::after': {
    display: 'none'
  },
  '& .MuiInputBase-root.Mui-focused::before, .MuiInputBase-root.Mui-focused::after, .MuiInputBase-root::before': {
    display: 'none'
  },
  '& input': {
    p: 1,
    '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
})

export const labelStyle = {
  fontWeight: 'bold',
  whiteSpace: 'nowrap',
  ml: 1,
  mb: 1,
  mt: 1,
  mr: 1
}

export const errorStyle = (theme: ITheme) => ({
  color: theme.palette.error.main,
  p: 1,
  fontWeight: 'bold'
})

export const buttonContainStyle = (theme: ITheme) => ({
  m: 1,
});

export const warningWrapper = (theme: ITheme) => ({
  display: 'flex',
  alignItems: 'center',
  mb: 1,
  '& img': {
    alignSelf: 'flex-start',
    mr: 1,
    width: 'auto'
  }
})

export const actionMsgStyle = {
  '&::before': {
    content: '""',
    display: 'block',
    height: '1px',
    width: '100%',
    background: theme.palette.grey[200],
    mt: 1,
    mb: 1,
  },
}